module.exports = __webpack_public_path__ + "img/6.a18164f6.png";